import React from "react";
import { ButtonLink } from "components/common/Button";
import { CombinedEvent } from "components/events/queries";
import { formatUSD } from "helpers/strings";

type EventRegisterExternallyProps = {
  event: CombinedEvent;
};

const SidebarRegisterExternally: React.FC<EventRegisterExternallyProps> = ({ event }) => {
  return (
    <>
      <div className="text-3xl font-bold mt-4">{formatUSD(Number(event.eventFields?.price))}</div>
      <ButtonLink
        className="my-4"
        theme="primary"
        href={event.eventFields?.registerLink || ""}
        target="_blank"
        rel="noopener noreferrer"
      >
        Register Now
      </ButtonLink>
    </>
  );
};

export default SidebarRegisterExternally;
